import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';
import { X } from 'lucide-react';
import { Box, DialogContent, Fade, Paper } from 'src/components/mui';
import ThemeConfig from 'src/theme';
import Iframe from '../Iframe';

type Props = {
  open: boolean;
  onClose: () => void;
  logo: string;
  url: string;
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Fade ref={ref} {...props} />;
});

export function TermsDialog({ open, logo, url, onClose }: Props) {
  return (
    <ThemeConfig>
      <Dialog
        sx={{ zIndex: 9999 }}
        fullScreen
        open={open}
        onClose={onClose}
        TransitionComponent={Transition}
      >
        <Paper
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 1,
          }}
          square
          elevation={5}
        >
          <Box height="48px" />
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
            sx={{ width: '37px', height: '36px' }}
          >
            <X size={20} />
          </IconButton>
        </Paper>
        <DialogContent
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            maxWidth: 'lg',
            marginX: 'auto',
          }}
        >
          <Iframe logoSrc={logo} title="iframe" src={url} />
        </DialogContent>
      </Dialog>
    </ThemeConfig>
  );
}
